export const AUDITS_CLASS_GET_REQUESTING = "AUDITS_CLASS_GET_REQUESTING";
export const AUDITS_CLASS_GET_SUCCESS = "AUDITS_CLASS_GET_SUCCESS";
export const AUDITS_CLASS_GET_ERROR = "AUDITS_CLASS_GET_ERROR";